import React, { useEffect, useState } from "react";
import { useRecoilState } from "recoil";
import { residentApi } from "../fetchers";
import { tableState } from "../store";

const TableNewRow = ({ id, refetch }) => {
  const [obj, setObj] = useState({});
  const [newRowData, setNewRowData] = useRecoilState(tableState.newRowData);

  const handleRemoveRow = () => {
    const newData = newRowData.filter((value) => value.id !== id);
    setNewRowData(newData);
  };

  const handleInput = (e, target) => {
    setObj((prev) => {
      return {
        ...prev,
        [target]: e.target.value,
      };
    });
  };

  const handleSelectChange = (e, target) => {
    if (target === "owner") {
      if (e === false) {
        setObj((prev) => {
          return {
            ...prev,
            isOwner: 0,
          };
        });
      } else if (e === true) {
        setObj((prev) => {
          return {
            ...prev,
            isOwner: 1,
          };
        });
      }
    } else if (target === "resident") {
      if (e === false) {
        setObj((prev) => {
          return {
            ...prev,
            isResident: 0,
          };
        });
      } else if (e === true) {
        setObj((prev) => {
          return {
            ...prev,
            isResident: 1,
          };
        });
      }
    }
  };

  const handleSave = async () => {
    if (window.confirm("저장하시겠습니까?")) {
      const response = await residentApi.register(obj);
      if (response.data) {
        alert("저장되었습니다");
        refetch();
        handleRemoveRow();
      } else {
        alert(response.response.data.error.message);
      }
    }
  };

  useEffect(() => {
    if (obj.hasOwnProperty("birthDate") && obj.birthDate.length === 8) {
      setObj((prev) => {
        return {
          ...prev,
          birthDate: obj.birthDate
            .replace(/-/g, "")
            .replace(/(\d{4})(\d{2})(\d{2})/, "$1-$2-$3"),
        };
      });
    }
  }, [obj.birthDate]);

  useEffect(() => {
    if (obj.hasOwnProperty("phone") && obj.phone.length === 10) {
      setObj((prev) => {
        return {
          ...prev,
          phone: obj.phone.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3"),
        };
      });
    } else if (obj.hasOwnProperty("phone") && obj.phone.length === 13) {
      setObj((prev) => {
        return {
          ...prev,
          phone: obj.phone
            .replace(/-/g, "")
            .replace(/(\d{3})(\d{4})(\d{4})/, "$1-$2-$3"),
        };
      });
    }
  }, [obj.phone]);

  return (
    <div>
      <div className={"row mx-0 align-items-center border-bottom"}>
        <div
          className={"list-group-item border-0"}
          style={{ width: "55px" }}
        ></div>
        <div className={"list-group-item border-0"} style={{ width: "90px" }}>
          <input
            className="form-control text-center"
            placeholder="동"
            onBlur={(e) => handleInput(e, "dong")}
          />
        </div>

        <div className={"list-group-item border-0"} style={{ width: "90px" }}>
          <input
            className="form-control text-center"
            placeholder="호"
            onBlur={(e) => handleInput(e, "ho")}
          />
        </div>
        <div className={"list-group-item border-0"} style={{ width: "130px" }}>
          <input
            className="form-control text-center"
            placeholder="이름 입력"
            onBlur={(e) => handleInput(e, "name")}
          />
        </div>
        <div className={"list-group-item border-0"} style={{ width: "150px" }}>
          <input
            className="form-control text-center"
            placeholder="1990-00-00"
            value={obj.birthDate || ""}
            onChange={(e) => handleInput(e, "birthDate")}
            maxLength={10}
          />
        </div>
        <div className={"list-group-item border-0"} style={{ width: "180px" }}>
          <input
            className="form-control text-center"
            placeholder="010-0000-0000"
            value={obj.phone || ""}
            onChange={(e) => handleInput(e, "phone")}
            maxLength={13}
          />
        </div>
        <div
          className={"list-group-item border-0 text-center"}
          style={{ width: "90px" }}
        ></div>
        <div
          className={"list-group-item border-0 text-center"}
          style={{ width: "90px" }}
        >
          <input
            type="checkbox"
            onChange={(e) => handleSelectChange(e.target.checked, "owner")}
          />
        </div>
        <div
          className={"list-group-item border-0 text-center"}
          style={{ width: "90px" }}
        >
          <input
            type="checkbox"
            onChange={(e) => handleSelectChange(e.target.checked, "resident")}
          />
        </div>

        <div
          className={"list-group-item border-0 text-center"}
          style={{ width: "150px" }}
        >
          <span className="cursor-pointer" onClick={handleRemoveRow}>
            취소
          </span>
          <span
            className="cursor-pointer text-primary ml-3"
            onClick={handleSave}
          >
            저장
          </span>
        </div>
      </div>
    </div>
  );
};

export default TableNewRow;
